<div class="modal-header">
    <h3>{{modalData.modalTitle}}</h3>
</div>
<div class="modal-body">
    <quill-view [content]="modalData.modalMessage"></quill-view>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark"
            (click)="cancelClicked()">
        {{closeButtonText}}
    </button>
    <button type="button" id="{{modalData.actionID}}" class="btn" [ngClass]="{'btn-danger': (modalData.warningLevel == null || modalData.warningLevel == 'danger'), 'btn-primary': modalData.warningLevel == 'primary', 'btn-success': modalData.warningLevel == 'success'}"
            (click)="actionClicked()">
        {{modalData.modalAction}}
    </button>
</div>
